import UserAdminPage from './UserAdminPage';

export default UserAdminPage;
